import { PublicClientApplication } from "@azure/msal-browser";

// Reuses the org SSO app (FIG-Finance-CRM-React-SSO). swan.figk-12.com is a
// registered SPA redirect URI on this app. Microsoft only verifies identity;
// admin authorization is still done against crm UserMst (see AuthContext).
const msalInstance = new PublicClientApplication({
  auth: {
    clientId: "82d4a518-c600-445d-ab53-696fb28fea8c",
    authority: "https://login.microsoftonline.com/fa7fec11-41f6-42c0-bbfc-38ce489a9397",
    redirectUri: "https://swan.figk-12.com",
  },
  cache: { cacheLocation: "localStorage" },
});

let _init = null;
async function ensureInit() {
  if (!_init) _init = msalInstance.initialize();
  await _init;
}

// Opens the Microsoft sign-in popup and returns the account ({ username = email, name }).
export async function microsoftLogin() {
  await ensureInit();
  const res = await msalInstance.loginPopup({ scopes: ["openid", "profile", "email"] });
  return res.account;
}
